"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeGraphQlQueryFetchAggregateTypeByIds = exports.computeGraphQlFetchQueryFromQueryDefinition = exports.computeGraphQlQueryFromQueryDefinitionWithPagination = exports.computeGraphQlQueryFromQueryDefinition = void 0;
const client_1 = require("@apollo/client");
const computeGraphQlQueryFromQueryDefinition = (arg) => {
    var _a;
    const filterQuery = buildFilterQuery({
        queryDefinition: (_a = arg.queryDefinition) === null || _a === void 0 ? void 0 : _a.filter,
        keywordMap: arg.objectToMatchKeyWord,
        username: arg.username,
        userRoles: arg.userRoles,
    });
    return {
        query: `{
      ${arg.queryKey}${filterQuery ? `(filter:${filterQuery})` : ''}{
        label,
        id
      }
    }`,
    };
};
exports.computeGraphQlQueryFromQueryDefinition = computeGraphQlQueryFromQueryDefinition;
const computeGraphQlQueryFromQueryDefinitionWithPagination = (arg) => {
    var _a;
    const filterQuery = buildFilterQuery({
        queryDefinition: (_a = arg.queryDefinition) === null || _a === void 0 ? void 0 : _a.filter,
        keywordMap: arg.objectToMatchKeyWord,
        username: arg.username,
        userRoles: arg.userRoles,
    });
    let condition = `orderBy: LABEL_ASC, first: ${arg.limit}`;
    if (filterQuery && arg.searchText) {
        condition = `${condition}, filter: ${filterQuery.replace('{', `{label: {includesInsensitive: "${arg.searchText}"},`)}`;
    }
    else if (filterQuery) {
        condition = `${condition}, filter: ${filterQuery}`;
    }
    else if (arg.searchText) {
        condition = `${condition}, filter: {label: {includesInsensitive: "${arg.searchText}"}}`;
    }
    if (arg.after) {
        condition = `${condition}, after: "${arg.after}"`;
    }
    return {
        query: `{
     ${arg.queryKey}Connection(${condition}) {
    nodes {
      id
      label
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  }`,
    };
};
exports.computeGraphQlQueryFromQueryDefinitionWithPagination = computeGraphQlQueryFromQueryDefinitionWithPagination;
const computeGraphQlFetchQueryFromQueryDefinition = (arg) => {
    var _a;
    const filterQuery = buildFilterQuery({
        queryDefinition: (_a = arg.queryDefinition) === null || _a === void 0 ? void 0 : _a.filter,
        keywordMap: arg.objectToMatchKeyWord,
        username: arg.username,
        userRoles: arg.userRoles,
        value: arg.value,
        values: arg.values,
    });
    return client_1.gql `query assetsQuery($first: Int, $after: Cursor, $date: Datetime){
      ${arg.queryKey}: ${arg.queryKey}Connection(filter:${filterQuery
        ? `${filterQuery.replace('{', '{lastModelRefresh: {greaterThan: $date},')}, `
        : '{lastModelRefresh: {greaterThan: $date}}'}first: $first, after: $after, orderBy: LAST_MODEL_REFRESH_ASC) {
        edges {
          node{
            ${arg.dataFields}
            id
            label
            symbolKey
            primaryLocation {
              geojson
            }
          }
        }
        pageInfo{
          hasNextPage
          endCursor
        }
      }
    }`;
};
exports.computeGraphQlFetchQueryFromQueryDefinition = computeGraphQlFetchQueryFromQueryDefinition;
/**
 * This function converts the query definition provided in the configuration into a graphql query filter.
 * @param queryDefinition the query definition to convert to the filter query
 * @param keywordMap a mapping of keywords that can be used to replace specific values
 */
const buildFilterQuery = (arg) => {
    const { queryDefinition, keywordMap, username, userRoles, value, values } = arg;
    let output = '';
    if (queryDefinition) {
        if (queryDefinition.type === 'SimpleFilter') {
            const key = queryDefinition.relation === 'ONE-TO-ONE' ? queryDefinition.key + 'Id' : queryDefinition.key;
            // for a simple filter, just add in the filter string
            let filterPredicate = '';
            switch (queryDefinition.operator) {
                case 'EQUAL':
                    const option = queryDefinition.options;
                    filterPredicate = `equalTo: ${replaceOptionValueIfNeeded(option, keywordMap ? keywordMap[key] : undefined, username, value)}`; //options is a terrible name
                    break;
                case 'NULL':
                    filterPredicate = `isNull: true`;
                    break;
                case 'NOTNULL':
                    filterPredicate = `isNull: false`;
                    break;
                case 'INCLUDE':
                    //@ts-ignore
                    const options = queryDefinition.options === '$$_ROLES_$$' ? userRoles : queryDefinition.options === '$$_VALUES_$$' ? values : queryDefinition.options;
                    filterPredicate = `in: ${replaceOptionValueIfNeeded(options !== null && options !== void 0 ? options : [], keywordMap ? keywordMap[key] : undefined, username, value)}`;
            }
            output += `{${key}:{${filterPredicate}}}`;
        }
        if (queryDefinition.type === 'GroupFilter') {
            if (queryDefinition.condition.length === 0) {
                return '';
            }
            else if (queryDefinition.condition.length === 1) {
                // if only one, then skip the conjunction
                output += buildFilterQuery({
                    queryDefinition: queryDefinition.condition[0],
                    keywordMap,
                    username,
                    userRoles,
                    value,
                    values,
                });
            }
            else {
                //if multiple, add the concjunction and map all the possiblities
                switch (queryDefinition.conjunction) {
                    case 'AND':
                        output += '{ and: [';
                        break;
                    case 'OR':
                        output += '{ or: [';
                }
                output += queryDefinition.condition
                    .map(cond => buildFilterQuery({ queryDefinition: cond, keywordMap, username, userRoles, value, values }))
                    .filter(c => c)
                    .join(', ');
                output += ']}';
            }
        }
    }
    return output;
};
const computeGraphQlQueryFetchAggregateTypeByIds = (arg) => {
    return {
        query: `query AggregatesByIds($ids:[UUID!]!) {
      ${arg.queryKey}(filter:{id:{in:$ids}}){
        label,
        id
      }
    }
    `,
        variables: {
            ids: arg.ids,
        },
    };
};
exports.computeGraphQlQueryFetchAggregateTypeByIds = computeGraphQlQueryFetchAggregateTypeByIds;
const replaceOptionValueIfNeeded = (option, valueToReplaceWithMaybe, username, value) => {
    let result = option === '$$_SELF_$$' && valueToReplaceWithMaybe ? valueToReplaceWithMaybe : option;
    if (option === '$$_USER_$$') {
        result = username;
    }
    if (option === '$$_VALUE_$$') {
        result = value;
    }
    if (typeof result === 'string') {
        return `"${result}"`;
    }
    else if (Array.isArray(result)) {
        return `[${result.map(option => replaceOptionValueIfNeeded(option, valueToReplaceWithMaybe, username, value))
            .join(',')}]`;
    }
    return result;
};
//# sourceMappingURL=QueryDefinitionToGraphQLQuery.js.map